import { isArray, forEach2ObjArr, isObject, reqStringify, isDate } from './utils';
import { default as Pfmessage } from '../../message';
// 序列化params
const paramsSerialize = (params) => {
    let serializedParams = undefined;
    let jsonStringifiedParams = undefined;
    if (params) {
        if (isArray(params)) {
            jsonStringifiedParams = [];
            forEach2ObjArr(params, function (item) {
                if (item === null || typeof item === 'undefined') {
                    jsonStringifiedParams.push(item);
                }
                else {
                    jsonStringifiedParams.push(isObject(item) ? JSON.stringify(item) : item);
                }
            });
            serializedParams = reqStringify(jsonStringifiedParams);
        }
        else {
            jsonStringifiedParams = {};
            forEach2ObjArr(params, function (value, key) {
                let jsonStringifiedValue = value;
                if (value === null || typeof value === 'undefined') {
                    jsonStringifiedParams[key] = value;
                }
                else if (isDate(value)) {
                    jsonStringifiedValue = value.toISOString();
                }
                else if (isArray(value)) {
                    jsonStringifiedValue = value;
                }
                else if (isObject(value)) {
                    jsonStringifiedValue = JSON.stringify(value);
                }
                jsonStringifiedParams[key] = jsonStringifiedValue;
            });
            const tmp = reqStringify(jsonStringifiedParams);
            serializedParams = tmp;
        }
    }
    return serializedParams;
};
const defaultInit = {
    method: 'GET',
    credentials: 'include'
};
function Request(url, options) {
    const { data, params, requestType = 'json', getResponse, getFullData, includeCode, showErrorMessage = true, responseType, ..._init } = options || {};
    let _url = url;
    const serializedParams = paramsSerialize(params);
    if (serializedParams) {
        const urlSign = url.indexOf('?') !== -1 ? '&' : '?';
        _url = `${url}${urlSign}${serializedParams}`;
    }
    let init = {
        ...defaultInit,
        ..._init
    };
    init.method = options?.method?.toUpperCase() || 'GET';
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(init.method)) {
        const dataType = Object.prototype.toString.call(data);
        if (dataType === '[object, Object]' || dataType === '[object, Array]') {
            if (responseType === 'json') {
                init.headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    ...init.headers
                };
                init.body = JSON.stringify(data);
            }
            else if (responseType === 'form') {
                init.headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencodedw;charset=UTF-8',
                    ...init.headers
                };
            }
            else {
                init.headers = {
                    Accept: 'application/json',
                    ...init.headers
                };
                init.body = data;
            }
        }
    }
    return fetch(_url, init).then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
            if (responseType === 'blob') {
                return response;
            }
            const copy = response.clone();
            const dataJson = await copy.json();
            const { code, data } = dataJson || {};
            if (code === '0' || includeCode?.includes(code)) {
                const _data = getFullData ? dataJson : data;
                return getResponse ? { data: _data, response: copy } : _data;
            }
            else {
                throw dataJson;
            }
        }
        else {
            const dataJson = await response.clone().json();
            throw dataJson;
        }
    }).catch(error => {
        const errorMessage = typeof error === 'string' ? error : error?.message ? error?.message : false;
        showErrorMessage && errorMessage && Pfmessage.error(errorMessage);
        throw error;
    });
}
export default Request;
